import { workbooksConstants } from "../constants/workbooksConstants"

const initialState = {
  course: {},
  subcourses: {},
  lessons: {},
  decks: {},
  itemBanks: {},
  deckBanks: {},
  lessonStudents: {},
  itemBanksStudents: {},
  fetchingSubcourses: false,
  // True while switching programs/courses until new subcourses are loaded
  programTransitioning: false,
  fetchingLessons: false,
  fetchingAllLessonDecks: false,
  updatingExitTicketScore: {},
  courseProgress: {},
  fetchingLessonItemBank: false,
  resettingStudentExitTicket: {},
  fetchingActiveCourse: false,
  fetchingActiveCourseError: null,
  sections: {},
  items: {}
}

export function actMasteryResourcesReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case workbooksConstants.FETCH_ACTIVE_COURSE:
      return {
        ...state,
        fetchingActiveCourse: true,
        // Start transition as soon as a new course fetch begins
        programTransitioning: true,
        subcourses: {}
      }

    case workbooksConstants.FETCH_ACTIVE_COURSE_SUCCESS:
      return {
        ...state,
        course: payload,
        // Keep transitioning until subcourses load
        fetchingActiveCourse: false,
        programTransitioning: true,
        subcourses: {}
      }

    case workbooksConstants.FETCH_ACTIVE_COURSE_FAILURE:
      return {
        ...state,
        fetchingActiveCourseError: payload,
        fetchingActiveCourse: false,
        programTransitioning: false,
        subcourses: {}
      }

    case workbooksConstants.FETCH_ACT_SUBCOURSES:
      return {
        ...state,
        fetchingSubcourses: true,
        // Still transitioning while subcourses are being fetched
        programTransitioning: true,
        subcourses: {}
      }

    case workbooksConstants.FETCH_ACT_SUBCOURSES_SUCCESS:
      return {
        ...state,
        subcourses: { ...payload.subcourses },
        fetchingSubcourses: false,
        // Transition complete once subcourses are in place
        programTransitioning: false
      }

    case workbooksConstants.FETCH_ACT_SUBCOURSES_FAILURE:
      return {
        ...state,
        subcoursesError: payload,
        fetchingSubcourses: false,
        programTransitioning: false,
        subcourses: {}
      }

    case workbooksConstants.FETCH_LESSONS:
      return {
        ...state,
        fetchingLessons: true
      }

    case workbooksConstants.FETCH_LESSONS_SUCCESS:
      return {
        ...state,
        lessons: { ...state.lessons, ...payload.lessons },
        fetchingLessons: false
      }

    case workbooksConstants.FETCH_LESSONS_FAILURE:
      return {
        ...state,
        lessonsError: payload,
        fetchingLessons: false
      }

    case workbooksConstants.FETCH_LESSON_ITEM_BANK:
      return {
        ...state,
        fetchingLessonItemBank: true
      }

    case workbooksConstants.FETCH_LESSON_ITEM_BANK_SUCCESS:
      return {
        ...state,
        fetchingLessonItemBank: false,
        items: {
          ...state.items,
          ...payload.items
        },
        itemBanks: {
          ...state.itemBanks,
          ...payload.itemBanks
        }
      }
    case workbooksConstants.FETCH_LESSON_ITEM_BANK_FAILURE:
      return {
        ...state,
        fetchingLessonItemBank: false
      }

    case workbooksConstants.FETCH_ALL_LESSON_DECKS_REQUEST:
      return {
        ...state,
        fetchingAllLessonDecks: true
      }

    case workbooksConstants.FETCH_ALL_LESSON_DECKS_SUCCESS:
      return {
        ...state,
        deckBanks: {
          ...state.deckBanks,
          ...payload.deckBanks
        },
        decks: {
          ...state.decks,
          ...payload.decks
        },
        fetchingAllLessonDecks: false
      }

    case workbooksConstants.FETCH_ALL_LESSON_DECKS_FAILURE:
      return {
        ...state,
        fetchingAllLessonDecks: false,
        allLessonDecksError: payload
      }

    case workbooksConstants.FETCH_LESSON_STUDENTS_REQUEST:
      return {
        ...state,
        fetchingLessonStudents: true
      }

    case workbooksConstants.FETCH_LESSON_STUDENTS_SUCCESS:
      return {
        ...state,
        fetchingLessonStudents: false,
        lessonStudents: {
          ...state.lessonStudents,
          ...payload.lessonStudents
        }
      }

    case workbooksConstants.FETCH_LESSON_STUDENTS_FAILURE:
      return {
        ...state,
        fetchingLessonStudents: false,
        fetchLessonStudentsError: payload
      }

    case workbooksConstants.FETCH_ITEM_BANKS_STUDENTS_REQUEST:
      return {
        ...state,
        fetchingItemBanksStudents: true
      }

    case workbooksConstants.FETCH_ITEM_BANKS_STUDENTS_SUCCESS:
      return {
        ...state,
        fetchingItemBanksStudents: false,
        itemBanksStudents: {
          ...state.itemBanksStudents,
          ...payload.itemBanks
        }
      }

    case workbooksConstants.FETCH_ITEM_BANKS_STUDENTS_FAILURE:
      return {
        ...state,
        fetchingItemBanksStudents: false,
        fetchItemBanksStudentsError: payload
      }

    case workbooksConstants.SET_EXIT_TICKET_SCORE_REQUEST:
      return {
        ...state,
        updatingExitTicketScore: {
          ...state.updatingExitTicketScore,
          [payload.id]: true
        }
      }

    case workbooksConstants.SET_EXIT_TICKET_SCORE_SUCCESS:
      return {
        ...state,
        itemBanksStudents: {
          ...state.itemBanksStudents,
          [payload.id]: {
            ...state.itemBanksStudents[payload.id],
            ...payload.itemBank
          }
        },
        courseProgress: {
          ...state.courseProgress,
          ...payload.courseProgress
        },
        updatingExitTicketScore: {
          ...state.updatingExitTicketScore,
          [payload.id]: false
        }
      }

    case workbooksConstants.SET_EXIT_TICKET_SCORE_FAILURE:
      return {
        ...state,
        updatingExitTicketScore: {
          ...state.updatingExitTicketScore,
          [payload.id]: false
        },
        updatingExitTicketScoreError: payload.error
      }

    case workbooksConstants.RESET_STUDENT_EXIT_TICKET_REQUEST:
      return {
        ...state,
        resettingStudentExitTicket: {
          ...state.resettingStudentExitTicket,
          [payload.id]: true
        }
      }

    case workbooksConstants.RESET_STUDENT_EXIT_TICKET_SUCCESS:
      return {
        ...state,
        // itemBanksStudents: {
        //   ...state.itemBanksStudents,
        //   [payload.id]: null
        // },
        itemBanksStudents: {
          ...state.itemBanksStudents,
          [payload.id]: {
            ...state.itemBanksStudents[payload.id],
            ...payload.itemBank
          }
        },
        // courseProgress: {
        //   ...state.courseProgress,
        //   ...payload.courseProgress
        // },
        resettingStudentExitTicket: {
          ...state.resettingStudentExitTicket,
          [payload.id]: false
        }
      }

    case workbooksConstants.RESET_STUDENT_EXIT_TICKET_FAILURE:
      return {
        ...state,
        resettingStudentExitTicket: {
          ...state.resettingStudentExitTicket,
          [payload.id]: false
        },
        resettingStudentExitTicketError: payload.error
      }
    case workbooksConstants.FETCH_LESSIONSECTION_SUCCESS:
      return {
        ...state,
        sections: { ...state.sections, ...payload }
      }

    case workbooksConstants.CLEAR_SUBCOURSES:
      return {
        ...state,
        // Clearing subcourses implies we are changing context
        programTransitioning: true,
        subcourses: {}
      }

    case workbooksConstants.CLEAR_COURSE:
      return {
        ...state,
        course: {}
      }

    default:
      return state
  }
}
